import React, { Component } from "react";
import axios from "axios";
import Filter from "./Filter.jsx";
import hyperlinks from "../../../src/util/hyperlinks";

export default class FilterContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            activeFilters: this.props.activeFilters || { innovations: [], countries: [] },
            includePrivateSector: false,
        };
        this.handlePanelClick = this.handlePanelClick.bind(this);
        this.handleOptionClick = this.handleOptionClick.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.privateSectorClick = this.privateSectorClick.bind(this);
    }

    handlePanelClick(e) {
        if (e.target.className.match("panel-body") || e.target.parentElement.className.match("panel-body") || e.target.className.match("corporate-input") || e.target.className.match("search-input")) return;
        this.setState({ open: !this.state.open });
    }

    privateSectorClick(e) {
      e.stopPropagation();
      e.preventDefault();

      const targetURL = `/members/${(this.props.group || "blank").toLowerCase() == "board members" ?
            hyperlinks["advisoryBoardMembers"].split("members/")[1] :
            hyperlinks["currentMembers"].split("members/")[1]}.json`;

      this.setState({ includePrivateSector: !this.state.includePrivateSector}, () => {
          axios.get(targetURL, {
              params: {
                  filters: this.state.activeFilters,
                  include_corporate: this.state.includePrivateSector
              }
          }).then((res) => {
              this.props.updateMembers(res.data);
          }).catch(err => {
              console.log(err);
          });
      });

      this.props.resetExpandedCards();
    }

    handleOptionClick(e) {
        e.preventDefault();
        e.stopPropagation();
        let newFilters = Object.assign({}, this.state.activeFilters);
        if (e.target.dataset.innovationId) {
            const id = e.target.dataset.innovationId.toString();
            if (this.state.activeFilters.innovations.includes(id)) {
                const index = newFilters.innovations.indexOf(id);
                newFilters.splice(index, 1);
            } else {
                newFilters.innovations.push(id);
            }
        }
        if (e.target.dataset.country) {
            const country = e.target.dataset.country;
            if (this.state.activeFilters.countries.includes(country)) {
                const index = newFilters.countries.indexOf(country);
                newFilters.splice(index, 1);
            } else {
                newFilters.countries.push(country);
            }
        }

        const targetURL = `/members/${(this.props.group || "blank").toLowerCase() == "board members" ?
            hyperlinks["advisoryBoardMembers"].split("members/")[1] :
            hyperlinks["currentMembers"].split("members/")[1]}.json`;

        this.setState({ activeFilters: newFilters }, () => {
            axios.get(targetURL, {
                params: {
                    filters: this.state.activeFilters,
                    include_corporate: this.state.includePrivateSector
                }
            }).then((res) => {
                this.props.updateMembers(res.data);
            }).catch(err => {
                console.log(err);
            });
        });
        this.props.resetExpandedCards();
    }

    clearFilters(e) {
        e.stopPropagation();

        const targetURL = `/members/${(this.props.group || "blank").toLowerCase() == "board members" ?
            hyperlinks["advisoryBoardMembers"].split("members/")[1] :
            hyperlinks["currentMembers"].split("members/")[1]}.json`;

        this.setState({ activeFilters: { innovations: [], countries: [] } }, () => {
            axios.get(targetURL, {
                params: {
                    filters: this.state.activeFilters,
                    include_corporate: this.state.includePrivateSector
                }
            }).then((res) => {
                this.props.updateMembers(res.data);
            }).catch(err => {
                console.log(err);
            });
        });
        this.props.resetExpandedCards();
        this.props.handleSearchInput("");
    }

    render() {
        return(
            <Filter
                group={this.props.group}
                innovationAreas={this.props.innovationAreas}
                activeFilters={this.state.activeFilters}
                open={this.state.open}
                handlePanelClick={this.handlePanelClick}
                handleOptionClick={this.handleOptionClick}
                clearFilters={this.clearFilters}
                privateSectorClick={this.privateSectorClick}
                includePrivateSector={this.state.includePrivateSector}
                countries={this.props.countries}
                handleSearchInput={this.props.handleSearchInput}
                searchQuery={this.props.searchQuery}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/FilterContainer.jsx.erb